module.exports = __webpack_public_path__ + "img/1072133015.88f68f55.jpg";